import { createContext } from 'react';

// prettier-ignore
export type AriaLiveContextType = {
  announce: (message: string, politeness?: 'assertive' | 'polite') => void;
} | undefined;

export const AriaLiveContext = createContext<AriaLiveContextType>(undefined);
